// Stripe imports
import ProductSelection from './ProductSelection';
import { useState } from 'react';
import Header from '../../header';
import { apiPost } from '../../utils/api';
import Loading from '../Loading';
import ErrorPage from '../pages/Error';
import { useCurrentOrganization } from 'src/contexts/OrganizationContext';

// const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY!);
// const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_TEST_PUBLISHABLE_KEY!);

interface ProductData {
  product: {
    id: string;
    name: string;
    description: string;
    active: boolean;
  };
  prices: Array<{
    id: string;
    unit_amount: number;
    currency: string;
    recurring: {
      interval: string;
    };
    type: string;
  }>;
}

export default function BillingCheckout() {
  const [ isLoading, setIsLoading ] = useState(false);
  const [ error, setError ] = useState<string | null>(null);
  const [ selectedProduct, setSelectedProduct ] = useState<ProductData | null>(null);
  const organization = useCurrentOrganization();

  const handleProductSelect = async (productData: ProductData) => {
    try {
      if (!organization) throw new Error('Organization is required');
      setIsLoading(true);
      setError(null);
      setSelectedProduct(productData);
      const response = await apiPost(`/api/${organization.id}/billing/create-subscription`, { productData });
      const data = await response.json();
      if (data.error) throw new Error(data.error);
      window.location.href = data.url;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An error occurred');
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Header isAdminPage={true} />
        <div className="flex items-center justify-center h-screen">
          <Loading message="Loading Subscription..." />
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <ErrorPage
        title="Payment Error"
        message="There was an issue processing your payment. Please try again."
        redirectURL={`/${organization.id}/billing`}
        buttonText="Back to Billing Settings"
      />
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header isAdminPage={true} />

      <div className="space-y-6 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <ProductSelection onProductSelect={handleProductSelect} />
      </div>
    </div>
  );
}
